import { useEffect, useRef, useState, useMemo } from "react";
import React from "react";

import { cloneDeep } from "lodash";

export const dateToYYYYMMDDString = (d) => {
    return d.toISOString().split("T")[0];
};

export function removeEmpty(obj) {
    const result = cloneDeep(obj);
    Object.keys(result).forEach(
        (key) =>
            (result[key] && typeof result[key] === "object" && removeEmpty(result[key])) ||
            ((typeof result[key] === "undefined" || result[key] === "") && delete result[key])
    );
    return result;
}

export function removeNull(inObj: any) {
    function removeNulls(obj) {
        const isArray = obj instanceof Array;
        let k: any;
        for (k in obj) {
            if (obj[k] === null) {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                isArray ? obj.splice(k, 1) : delete obj[k];
            } else if (typeof obj[k] === "object") {
                removeNulls(obj[k]);
            }
            if (isArray && obj.length === k) {
                removeNulls(obj);
            }
        }
        return obj;
    }
    const obj = cloneDeep(inObj);
    return removeNulls(obj);
}

export function isValidYYYYMMDD(date) {
    const expression = RegExp("^[0-9]{4}-[0-9]{2}-[0-9]{2}$");
    return expression.test(date);
}

export function isValidYYYYMMDDHHMMSS(date) {
    //eslint-disable-next-line
    let expression = RegExp(
        "^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$"
    );
    return expression.test(date);
}

export const isArrayOfObjects = (data: any): boolean => {
    if (!Array.isArray(data)) return false;
    data.forEach((element) => {
        if (typeof element !== "object") return false;
    });
    return true;
};

export const getKeysFromArrayOfObjects = (data) => {
    const fields = {};
    for (let i = 0; i !== data.length; ++i) {
        const row = data[i];
        if (row) {
            Object.keys(row).forEach((key) => {
                if ((typeof key === "string" || typeof "number") && !fields[key]) {
                    fields[key] = true;
                }
            });
        }
    }
    return Object.keys(fields);
};

export const generate128CharactersKey = (): string => {
    const array = new Uint8Array(64);
    crypto.getRandomValues(array);
    return Array.from(array, (b) => b.toString(16).padStart(2, "0")).join("");
};

// does this works in react-19?
export function usePrevious<T = any>(value: T): T {
    const ref = useRef<T>(value);
    const prev = ref.current;
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return prev;
}

export function addWeekDays(date: string, n: number): string {
    let newDate = new Date(new Date(date).getTime() + 86400000 * n);
    if (newDate.getDay() === 6) {
        //Saturday
        newDate = new Date(newDate.getTime() + 86400000 * 2);
    } else if (newDate.getDay() === 0) {
        //Sunday
        newDate = new Date(newDate.getTime() + 86400000 * 1);
    }
    return newDate.toJSON().slice(0, 10);
}

export function generateRandomString(length: number): string {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

//https://usehooks-typescript.com/react-hook/use-interval
export function useInterval(callback: () => void, delay: number | null) {
    const savedCallback = useRef(callback);

    // Remember the latest callback if it changes.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        // Don't schedule if no delay is specified.
        if (delay === null) {
            return;
        }

        const id = setInterval(() => savedCallback.current(), delay);

        return () => clearInterval(id);
    }, [delay]);
}

export function useAlertTimeOut(
    alert: Record<string, string | boolean>,
    setAlert: React.Dispatch<React.SetStateAction<any>>,
    secondsToShow: number
) {
    const [secondsToShowAlert, setSecondsToShowAlert] = useState(secondsToShow);

    const dismissAlert = useMemo(() => {
        const dismiss = cloneDeep(alert);
        dismiss.color = "info";
        dismiss.visible = false;
        dismiss.message = "";
        return dismiss;
    }, [alert]);

    useEffect(() => {
        let interval = null;
        const isActive = alert.visible && alert.color === "success";

        if (isActive) {
            interval = setInterval(() => {
                setSecondsToShowAlert((prevSeconds) => prevSeconds - 1);
            }, 1000);
            if (secondsToShowAlert < 0) {
                clearInterval(interval);
                setAlert(dismissAlert);
            }
        } else if (!isActive) {
            if (secondsToShowAlert !== secondsToShow) {
                setSecondsToShowAlert(secondsToShow);
            }
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [alert, dismissAlert, secondsToShow, secondsToShowAlert]);
}

export const parseSwedishPersonalNumber = (s: string, requireMatch: boolean): string => {
    if (!s) return null;
    const reg = /^(19|20)?([0-9]{2})([01][0-9](?:[0-2][0-9]|3[01]))-?([0-9]{4})$/gm;
    const m = reg.exec(s);
    if (!m) return requireMatch ? null : s;
    const h = m[1];
    const y = parseInt(m[2], 10);
    let year: string;
    if (typeof h === "undefined") {
        return null;
    } else {
        year = h + y;
    }
    const monthDay = m[3];
    const code = m[4];
    return year + monthDay + code;
};
